import React, { Component } from 'react'
import { SecureContainer, FormInput } from '../../components'
import { recoveryPassword } from '../../api'
import qs from 'qs';

class Recovery extends Component {
    state = {
        success: false,
        access_token: undefined,
        password: undefined
    }
    componentDidMount() {
        const query = qs.parse(window.location.href.split('?')[1]);
        console.log(query)
        this.setState({ access_token: query.access_token })
    }
    submit = (event) => {
        event.preventDefault()
        recoveryPassword(this.state.access_token, this.state.password).then((data) => {
            this.setState({ success: true })
        }).catch(err => {
            alert(err.message)
        })
    }
    render() {
        return (
            <SecureContainer
                title="Reset Password">
                {this.state.success && (
                    <div>
                        <p>Password changed, you can now enter Masar with your new password.</p>
                        <a href="/" className="btn btn-info btn-block" style={{ marginTop: '24px' }}>Back to Login</a>
                    </div>
                )}
                {!this.state.success && (
                    <form onSubmit={this.submit}>

                        {this.state.error && (
                            <div>
                                <span style={{ color: 'red' }}>{this.state.error_message}</span>
                            </div>
                        )}

                        <FormInput
                            onChange={(text) => {
                                this.setState({ password: text })
                            }}
                            type="password"
                            value={this.state.password}
                            required
                            placeholder="New Password" />

                        <button type="submit" className="btn btn-info btn-block" style={{ marginTop: '24px' }}>Reset Password</button>
                    </form>
                )}
            </SecureContainer>
        )
    }
}

export default Recovery;


// WEBPACK FOOTER //
// ./src/routers/Recovery/index.js